import React from "react";
import axios from "axios";
import { Table, Button, Input, Icon, Divider, Popconfirm, message } from 'antd';
import { withRouter } from "react-router-dom";
import EventForm from "./EventForm";
import { withTranslation } from 'react-i18next';
const { Search } = Input;


class EventList extends React.Component {
    state = {
        selectedRowKeys: [],
        modalEvent: {},
        modalRequestType: '',
        // modalLoading: true,
        modalBtnText: "",
        modalVisible: false,
        modalTitleText: "",

        tags: [],
        users: [],
        contacts: [],
        event_type_list: [],
        event_status_list: [],
        lead_list: []
    };


    componentDidMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
        axios.defaults.headers = {
            "Content-Type": "application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };
        this.fetch();
    }

    fetch = e => {
        let requestList = [];
        requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/tags/"));
        requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/users_list/"));
        requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/contacts_list/"));
        requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/choice_event_type_list/"));
        requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/choice_event_status_list/"));
        requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/leads_list/"));

        axios.all(requestList).then(axios.spread((...responses) => {
            const responseTags = responses[0];
            const responseUsers = responses[1];
            const responseContacts = responses[2];
            const responseEventType = responses[3];
            const responseStatus = responses[4];
            const responseLeads = responses[5];

            this.setState({
                tags: responseTags.data,
                users: responseUsers.data,
                contacts: responseContacts.data,
                event_type_list: responseEventType.data,
                event_status_list: responseStatus.data,
                lead_list: responseLeads.data
            });
        })).catch(errors => {
            console.log(errors);
        });
    }

    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.props.pagination };
        pager.current = pagination.current;

        let sorter_field = sorter.field;
        if (sorter_field && sorter_field.includes("display"))
            sorter_field = sorter_field.substring(0, sorter_field.length - 8);

        this.props.handleState('pagination', pager);
        this.props.handleState('sortedInfo', {
            order: sorter.order,
            columnKey: sorter_field
        });
        this.props.fetch({
            results: pagination.pageSize,
            page: pagination.current,
            sortField: sorter_field,
            sortOrder: sorter.order
        });
    };

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    handleDeleteSelected = (event) => {
        this.props.handleState('loading', true);
        this.state.selectedRowKeys.filter((key, index) => {
            axios.delete(process.env.REACT_APP_AXIOS_URL + `/api/events/${key}/delete/`)
                .then(res => {
                    if (res.status === 204 || res.status === 200) {
                        return true;
                    }
                })
        });

        let data = this.props.data;
        data = data.filter(item => {
            return !this.state.selectedRowKeys.includes(item.id);
        });
        setTimeout(() => {
            this.props.handleState('data', data);
            this.props.handleState('loading', false);
            this.setState({
                selectedRowKeys: [],
            });
        }, 1000);
    };

    handleState = (key, value) => {
        let obj = {};
        obj[key] = value;
        this.setState(obj);
    }

    handleSearch = (value) => {
        this.props.handleState('searchText', value);
        this.props.fetch({
            search: value,
            sortField: this.props.sortedInfo['columnKey'],
            sortOrder: this.props.sortedInfo['order']
        });
    };


    handleDelete(eventID, recordID) {
        axios.delete(process.env.REACT_APP_AXIOS_URL + `/api/events/${eventID}/delete/`)
            .then(res => {
                if (res.status === 204 || res.status === 200) {
                    const data = [...this.props.data];
                    delete data[recordID];
                    const data_fixed = data.filter(item => item.key !== recordID)
                    this.props.handleState('data', data_fixed);
                    message.success(this.props.t('events.event_list.event_deleted', "Event deleted"));
                } else {
                    message.warning(this.props.t('events.event_list.event_deletion_failed', "Deletion failed"));
                }
            })
    };

    confirmDelete(event, eventID, recordID) {
        event.preventDefault();
        this.handleDelete(eventID, recordID);
    }

    showModal = () => {
        this.formRef.resetFields();
        this.setState({
            modalVisible: true,
            modalTitleText: this.props.t('events.event_list.modal_title_create', "Create a new event"),
            modalRequestType: "post",
            modalBtnText: this.props.t('general.create', "Create"),
            modalEvent: {},
        });
    };

    hideModal = () => {
        this.setState({
            modalVisible: false,
        });
    };

    handleCreate = () => {
        this.formRef.validateFields((err, values) => {
            if (err) {
                return;
            }

            const postObj = {
                ...values
            }

            this.hideModal();
            axios.post(process.env.REACT_APP_AXIOS_URL + "/api/events/create/", postObj)
                .then(res => {
                    if (res.status === 201) {
                        this.props.fetch();
                        message.success(this.props.t('events.event_list.event_created', "Event created successfully"));
                    }
                })

            this.formRef.resetFields();
        });
    };

    handlePreview = event => {
        const eventID = event.currentTarget.getAttribute('data-record_id');
        this.formRef.resetFields();
        axios.get(process.env.REACT_APP_AXIOS_URL + `/api/events/${eventID}/`)
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        modalEvent: res.data,
                        // modalLoading: false,
                        modalBtnText: undefined,
                        modalVisible: true,
                        modalRequestType: "get",
                        modalTitleText: this.props.t('events.event_list.modal_title_preview', "Previewing a event")
                    });
                } else {
                    this.props.history.push('/events');
                }
            })
    };

    handleEditPreview = event => {
        const eventID = event.currentTarget.getAttribute('data-record_id');
        this.formRef.resetFields();
        axios.get(process.env.REACT_APP_AXIOS_URL + `/api/events/${eventID}/`)
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        modalEvent: res.data,
                        // modalLoading: false,
                        modalBtnText: this.props.t('general.update', "Update"),
                        modalVisible: true,
                        modalRequestType: "put",
                        modalTitleText: this.props.t('events.event_list.modal_title_update', "Update event")
                    });
                } else {
                    this.props.history.push('/events');
                }
            })
    };

    handleEdit = event => {
        this.formRef.validateFields((err, values) => {
            if (err) {
                return;
            }

            const postObj = {
                ...values
            }
            const eventID = this.state.modalEvent.id;
            this.hideModal();
            axios.put(process.env.REACT_APP_AXIOS_URL + `/api/events/${eventID}/update/`, postObj)
                .then(res => {
                    if (res.status === 200) {
                        this.props.fetch();
                        message.success(this.props.t('events.event_list.event_updated', "Event have been updated"));
                    }
                })

            // this.formRef.resetFields();
        });
    };

    saveFormRef = formRef => {
        this.formRef = formRef;
    };

    render() {
        const { selectedRowKeys } = this.state;
        const { t } = this.props;

        const columns = [
            {
                title: t('events.event_list.name', "Name"),
                dataIndex: 'name',
                key: 'name',
                sorter: true,
                ellipsis: true,
            },
            {
                title: t('events.event_list.type', "Event type"),
                dataIndex: 'event_type_display',
                key: 'event_type',
                sorter: true,
                ellipsis: true,
            },
            {
                title: t('events.event_list.status', "Status"),
                dataIndex: 'status_display',
                key: 'status',
                sorter: true,
                ellipsis: true,
            },
            {
                title: t('events.event_list.start_date', "Start date"),
                dataIndex: 'start_date',
                key: 'start_date',
                sorter: true,
                ellipsis: true,
            },
            {
                title: t('events.event_list.end_date', "End date"),
                dataIndex: 'end_date',
                key: 'end_date',
                sorter: true,
                ellipsis: true,
            },
            {
                title: t('general.actions', "Actions"),
                ellipsis: true,
                render: (text, record, index) => (
                    <span>
                        <a onClick={this.handlePreview} data-record_id={record.id}>{t('general.view', "View")}</a>
                        <Divider type="vertical" />
                        <a onClick={this.handleEditPreview} data-record_id={record.id}>{t('general.edit', "Edit")}</a>
                        <Divider type="vertical" />
                        <Popconfirm
                            title={t('events.event_list.event_delete', "Are you sure want to delete this event?")}
                            onConfirm={(event) => {
                                this.confirmDelete(event, record.id, index);
                            }}
                            okText={t('general.yes', "Yes")}
                            cancelText={t('general.no', "No")}
                            className='data-id={record.id}'
                        >
                            <a href="#">{t('general.delete', "Delete")}</a>
                        </Popconfirm>
                    </span>
                ),
            }
        ];

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            hideDefaultSelections: true,
            selections: [
                {
                    key: 'delete',
                    text: t('general.delete', "Delete"),
                    onSelect: this.handleDeleteSelected
                },
            ],
        };

        let admins;
        admins = this.state.users.filter(item => item.role === "ADMIN");

        return (
            <div>
                <div className="to-do-header">
                    <Search
                        placeholder={t('events.event_list.search', "Find event")}
                        onSearch={value => this.handleSearch(value)}
                        style={{ width: 200, margin: 8 }}
                    />
                    <div style={{ float: 'right' }}>
                        <Button style={{ margin: 8 }} type="primary" onClick={this.showModal}>
                            <Icon type="plus" />
                            {t('general.create', "Create")}
                        </Button>
                    </div>
                </div>
                <div className="to-do-content">
                    <Table
                        rowSelection={rowSelection}
                        columns={columns}
                        onChange={this.handleTableChange}
                        rowKey={record => record.id}
                        dataSource={this.props.data}
                        pagination={this.props.pagination}
                        loading={this.props.loading}
                    />
                </div >
                <EventForm
                    wrappedComponentRef={(form) => this.formRef = form}
                    visible={this.state.modalVisible}
                    onCancel={this.hideModal}
                    btnText={this.state.modalBtnText}
                    titleText={this.state.modalTitleText}
                    handleState={this.handleState}
                    requestType={this.state.modalRequestType}
                    data={this.state.modalEvent}
                    fetch={this.props.fetch}
                    tags={this.state.tags}
                    users={admins}
                    contacts={this.state.contacts}
                    event_type_list={this.state.event_type_list}
                    event_status_list={this.state.event_status_list}
                    lead_list={this.state.lead_list}
                />
            </div>
        );
    }
}


export default withRouter(withTranslation()(EventList));



// WEBPACK FOOTER //
// ./src/containers/Events/EventList.js